import { IComponentController } from 'angular';
//import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireGroupeAccordeonClass } from '../../../../../core/services/formulaire/formulaire-groupe-accordeon.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IMenuItemForage, IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IMenu, IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IOperateurService } from '../../../../../core/services/operateur.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IStateService } from 'angular-ui-router';
import { IFormulaireItemSautDeColonneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-colonne.service';

interface IPageRe0002 extends IComponentController {
    menuBandeau: IMenu;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    rhaMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rhaMultiOccurrence: IMultiOccurrence;
    rtcMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rtcMultiOccurrence: IMultiOccurrence;
    rtiMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rtiMultiOccurrence: IMultiOccurrence;
    rcsMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rcsMultiOccurrence: IMultiOccurrence;
    rmnMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rmnMultiOccurrence: IMultiOccurrence;
    rtzMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rtzMultiOccurrence: IMultiOccurrence;
    risMultiOccurrenceOptions: IMultiOccurrenceOptions;
    risMultiOccurrence: IMultiOccurrence;
    rbqMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rbqMultiOccurrence: IMultiOccurrence;
    rorMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rorMultiOccurrence: IMultiOccurrence;
    ocdMultiOccurrenceOptions: IMultiOccurrenceOptions;
    ocdMultiOccurrence: IMultiOccurrence;
    rinMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rinMultiOccurrence: IMultiOccurrence;
    rmsMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rmsMultiOccurrence: IMultiOccurrence;
    rmsDetMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rmsDetMultiOccurrence: IMultiOccurrence;
    valeursEcran: any;
    extMenus: Array<IMenuItemForage>;
    formulaireRtc: IFormulaire;
}
/* @ngInject */
export default function Re0002Controller(
    Menu: IMenuClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    FormulaireItemSautDeColonne: IFormulaireItemSautDeColonneClass,
    FormulaireGroupeAccordeon: IFormulaireGroupeAccordeonClass,
    MenuItemAction: IMenuItemActionClass,
    MenuItemForage: IMenuItemForageClass,
    $state: IStateService,
    mc0046Route: IRoute,
    re0011Route: IRoute,
    re0012Route: IRoute,
    re0007Route:IRoute,
    re0023Route: IRoute,
    accueilRoute: IRoute, // Pour les forages qui n'existe pas encore... 
    MenuItemEcran: IMenuItemEcranClass,
    Operateur: IOperateurService
) {
    const vm: IPageRe0002 = this;
    vm.$onInit = $onInit;

    function $onInit() {
        vm.menuBandeau = new Menu([]);
        vm.valeursEcran = ecranDetails.valeurs;

        vm.monoOccurrenceOptions = {
            successActionSauvegarde: () => {
                vm.monoOccurrence?.fetchData();
            },
            fonctions: {
                afficherMenusDansEntete: true,
                importation: true,
                boutonDupliquer: false
            },
            menus: [
                new MenuItemAction('LBL_BTN_ANNULER', 'BOUANN', () => ({}), {
                    iconButton: false,
                    icon: '',
                    class: 'md-raised ex-button-secondary',
                    saveFirst: true,
                    messageConfirmation: 'BOUANN_CONFIRM',
                    successAction: () => {
                        vm.monoOccurrence.fetchData();
                    },
                    disabled: () => !(vm.monoOccurrence.data.aut__vaertostu === 'INI' || vm.monoOccurrence.data.aut__vaertostu === 'ENC')
                }),
                new MenuItemAction('LBL_BTN_EXTRAIRE', 'BOUEXT', () => ({}), {
                    iconButton: false,
                    icon: '',
                    class: 'md-raised ex-button-action',
                    saveFirst: true,
                    messageConfirmation: 'BOUEXT_CONFIRM',
                    successAction: () => {
                        vm.monoOccurrence.fetchData();
                        $state.reload();
                    },
                    disabled: () => !(vm.monoOccurrence.data.aut__vaertostu === 'INI')
                }),
                new MenuItemAction('LBL_BTN_MAJSAL', 'BOUMAJ', () => ({}), {
                    iconButton: false,
                    icon: '',
                    class: vm.valeursEcran.vaertostu === 'ENC' ? 'md-raised ex-button-secondary' : 'md-raised ex-button-action',
                    saveFirst: true,
                    messageConfirmation: vm.valeursEcran.vaertostu === 'ENC' ? 'BOUMAJOK_CONFIRM' : 'BOUMAJ_CONFIRM',
                    successAction: () => {
                        vm.monoOccurrence.fetchData();
                    },
                    disabled: () => !(vm.monoOccurrence.data.aut__vaertostu === 'ENC') || vm.valeursEcran.vaertotyp === '02' || vm.valeursEcran.vaertotyp === '05'
                }),
                new MenuItemAction('LBL_BTN_CALCULER', 'BOUCAL', () => ({}), {
                    iconButton: false,
                    icon: '',
                    class: vm.valeursEcran.vaertotyp === '02' || vm.valeursEcran.vaertotyp === '05' ? 'md-raised ex-button-secondary' : 'md-raised ex-button-action',
                    saveFirst: true,
                    formulaireConfirmationAction: {
                        lblTitre: 'LBL_CALCUL_RETRO',
                        lblConfirm: 'LBL_CALCUL',
                        actionsSecondaires: [
                            new MenuItemAction('LBL_CALCUL_DBG', 'CALDBG', () => ({}), {
                                icon: '',
                                iconButton: false,
                                successAction: () => {
                                    vm.monoOccurrence.fetchData();
                                },
                                hidden: !vm.valeursEcran.calint
                            })
                        ],
                        largeurFormulaire: 25,
                        formulaire: new Formulaire([
                            new FormulaireItem('demcleint', {
                                largeur: 100,
                                required: true,
                                resourceParams: (data: any) => ({
                                    rtocleint: data.rtocleint
                                })
                            })
                        ])
                    },
                    successAction: () => {
                        vm.monoOccurrence.fetchData();
                    },
                    disabled: () => !(vm.monoOccurrence.data.aut__vaertostu === 'ENC')
                }),
                new MenuItemAction('LBL_BTN_CALCINT', 'BOUCALINT', () => ({}), {
                    iconButton: false,
                    icon: '',
                    class: vm.valeursEcran.vaertotyp === '02' || vm.valeursEcran.vaertotyp === '05' ? 'md-raised ex-button-secondary' : 'md-raised ex-button-action',
                    saveFirst: true,
                    messageConfirmation: 'BOUCALINT_CONFIRM',
                    successAction: () => {
                        vm.monoOccurrence.fetchData();
                    },
                    disabled: () => !(vm.monoOccurrence.data.aut__vaertostu === 'ENC')
                }),
                new MenuItemAction('LBL_BTN_GENERER', 'BOUGEN', () => ({}), {
                    iconButton: false,
                    icon: '',
                    class: 'md-raised ex-button-action',
                    saveFirst: true,
                    messageConfirmation: 'BOUGEN_CONFIRM',
                    successAction: () => {
                        vm.monoOccurrence.fetchData();
                    },
                    disabled: () => !(vm.monoOccurrence.data.aut__vaertostu === 'ENC')
                })
            ]
        };
        vm.menus = [
            new MenuItemEcran(
                'LBL_IMPUT',
                mc0046Route.NAME,
                () => ({
                    vaeusient: 'RTF',
                    uvicleintref: vm.monoOccurrence.data.rtocleint
                }),
                {
                    icon: 'featured_play_list',
                    iconButton: false,
                    secondaire: true,
                    hidden: () => !vm.monoOccurrence.data.vaertomodcal || vm.monoOccurrence.data.aut__vaertostu === 'ANN'
                }
            ),
            new MenuItemEcran('LBL_RESUL', re0011Route.NAME, () => ({ rtocleint: vm.monoOccurrence.data.rtocleint }), {
                icon: 'assessment',
                iconButton: false,
                hidden: () => vm.valeursEcran.flgmaj !== 1 || vm.monoOccurrence.data.aut__vaertostu === 'ANN' || vm.monoOccurrence.data.aut__vaertostu === 'INI'
            }),
            new MenuItemForage(
                'LBL_CHEXT',
                // re0022Route.NAME, <-- existe pas encore
                accueilRoute.NAME,
                (data: any) => ({
                    rtocleint: data.rtocleint
                }),
                {
                    icon: 'assessment',
                    iconButton: false,
                    secondaire: true,
                    hidden: () =>
                        vm.monoOccurrence.data.aut__re0022_data === 0 ||
                        vm.monoOccurrence.data.aut__vaertostu === 'ANN' ||
                        vm.monoOccurrence.data.aut__vaertostu === 'TER' ||
                        vm.monoOccurrence.data.aut__vaertostu === 'INI'
                }
            )
        ];
           vm.extMenus = [
              /*  new MenuItemForage('LBL_ECHSAL', re0003Route.NAME, (data: any) => ({ id: data.rtocod, rtocleint: data.rtocleint }), {
                    icon: 'assessment',
                    secondaire: true,
                    iconButton: false
                }),
                new MenuItemForage('LBL_CLAEMP', re0009Route.NAME, (data: any) => ({ ecran: '01-2', rtocleint: data.rtocleint }), {
                    icon: 'assessment',
                    secondaire: true,
                    iconButton: false
                }),*/
                new MenuItemForage('LBL_PRIEMP', re0007Route.NAME, (data: any) => ({ rtocleint: data.rtocleint }), {
                    icon: 'assessment',
                    secondaire: true,
                    iconButton: false
                }),/*
                new MenuItemForage('LBL_TAG', re0012Route.NAME, (data: any) => ({ rtocleint: data.rtocleint }), {
                    icon: 'assessment',
                    secondaire: true,
                    iconButton: false
                }),
                new MenuItemForage('LBL_PARTAG', re0005Route.NAME, (data: any) => ({ rtocleint: data.rtocleint }), {
                    icon: 'assessment',
                    secondaire: true,
                    iconButton: false
                }),
                new MenuItemForage('LBL_PARRCE', re0014Route.NAME, (data: any) => ({ rtocleint: data.rtocleint }), {
                    icon: 'assessment',
                    secondaire: true,
                    iconButton: false
                })*/
            ];
        vm.formulaireRto = new Formulaire(
            'LBL_BLC_RTO',
            [
                new FormulaireItem('rtocod'),
                new FormulaireItem('rtodsc', { largeur: 75 }),
                new FormulaireItemSautDeLigne(),
                new FormulaireItem('vaertotyp'),
                new FormulaireItem('rtodatdeb'),
                new FormulaireItem('rtodatfin'),
                new FormulaireItem('rtodatpai'),
                new FormulaireItemSautDeLigne(),
                new FormulaireItem('vaertomodcal'),
                new FormulaireItem('rtocom', {
                    largeur: 75,
                    enableCount: true
                }),
                new FormulaireItemSautDeLigne(),
                new FormulaireItem('rtoflgcrelem', { largeur: 50 }),
                new FormulaireItem('rtoflgempnonmod', { largeur: 50, default: 1 }),
                new FormulaireGroupeAccordeon(
                    'LBL_ACCORDEON_AUTRES_INFOS',
                    new Formulaire(
                        [
                            new FormulaireItem('ttccleint', { nombreLibellesDetailsCacher: 1 }),
                            new FormulaireItem('ttccleintech', { nombreLibellesDetailsCacher: 1 }),
                            new FormulaireItem('tpfcleint')
                        ],
                        { largeurDefaut: 50 }
                    )
                )
            ],
            { largeurDefaut: 25 }
        );

        //Historique d'action
        vm.rhaMultiOccurrenceOptions = {
            bloc: 'rha',
            fonctions: {
                pagination: true
            },
            pagination: {
                nbElementsPossibles: [5, 10, 20],
                nombreElementPage: 5
            },
            colonnesVisibles: ['rhausrcod', 'rhausrnom', 'vaerhaactdsc', 'rhadatcre'],
            colonnesCachees: ['rhacleint', 'rtocleint', 'vaerhaact']
        };

        //conventions
        vm.rtcMultiOccurrenceOptions = {
            bloc: 'rtc',
            fonctions: {
                pagination: true,
                importation: true,
                nouveau: vm.valeursEcran.vaertostu  === 'INI',
                edition: vm.valeursEcran.vaertostu  === 'INI',
                supprime: vm.valeursEcran.vaertostu === 'INI'
            },
            pagination: {
                nbElementsPossibles: [5, 10, 20],
                nombreElementPage: 5
            },
            colonnesVisibles: ['cvtcod', 'cvtdsc'],
            formulaire: new Formulaire([new FormulaireItem('cvtcleint', { largeur: 100 })])
        };

        vm.rdeMultiOccurrenceOptions = {
            bloc: 'rde',
            reloadWithBlocs:['rto'],
            fonctions: {
                pagination: true,
                importation: true,
                nouveau: (vm.valeursEcran.vaertostu === 'INI'),
                edition: (vm.valeursEcran.vaertostu === 'INI'),
                supprime: (vm.valeursEcran.vaertostu === 'INI')
            },
            pagination: {
                nbElementsPossibles: [5, 10, 20],
                nombreElementPage: 5
            },
            colonnesVisibles: ['eplnummat', 'eplnomprn'],
            formulaire: new Formulaire([new FormulaireItem('demcleint', { largeur: 100 })])
        };

        //intervalles du paiment
        vm.rtiMultiOccurrenceOptions = {
            bloc: 'rti',
            fonctions: {
                pagination: true,
                importation: true,
                nouveau: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER'),
                edition: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER'),
                supprime: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER')
            },
            pagination: {
                nbElementsPossibles: [5, 10],
                nombreElementPage: 5
            },
            colonnesVisibles: [
                { nom: 'rtidatdeb', largeur: 100 },
                { nom: 'rtidatfin', largeur: 100 },
                { nom: 'tagcod', largeur: 110 },
                { nom: 'tagdscabr', largeur: 200 },
                { nom: 'rtiflgarr', largeur: 100 }                
            ],
            colonnesFixesDroite: [
                {
                    nom: 'flgrte',
                    largeur: 100,                    
                    menu: [
                        new MenuItemAction(                
                            'BOURTE',
                            (data: any) => ({ 
                                rtiflgarr: data.rtiflgarr,
                                rticleint: data.rticleint 
                            }),
                            {
                                icon: 'launch',
                                compteur: (data: any) => data.rtecnt,
                                successAction: (retour: any) => {
                                    const menuItemEcran = new MenuItemEcran('',
                                                                            re0023Route.NAME,
                                                                            () => {                                                   
                                                                                return { id: retour.rticleint };
                                                                            },
                                                                            {
                                                                                onClose: () => {
                                                                                    vm.rtiMultiOccurrence.fetchDataList();
                                                                                }
                                                                            });
                                    return menuItemEcran.action(null, {});
                                }
                            }
                        )                    
                    ] 
                }
            ],                 
            colonnesCachees: ['rticleint', 'vaertostu', 'rtecnt'],
            formulaire: new Formulaire([
                new FormulaireItem('rtidatdeb'),
                new FormulaireItem('rtidatfin'),
                new FormulaireItemSautDeLigne(),
                new FormulaireItem('tagcleintret'),
                new FormulaireItem('rtiflgarr', { default: 0 })
            ])
        };

        //Correspondances groupes d'echelle
        vm.rcsMultiOccurrenceOptions = {
            bloc: 'rcs',
            fonctions: {
                importation: true,
                nouveau: (vm.valeursEcran.vaertostu === 'INI' || vm.valeursEcran.vaertostu === 'ENC'),
                edition: (vm.valeursEcran.vaertostu === 'INI' || vm.valeursEcran.vaertostu === 'ENC'),
                supprime: (vm.valeursEcran.vaertostu === 'INI' || vm.valeursEcran.vaertostu === 'ENC')
            },
            colonnesVisibles: [
                { nom: 'temcodtri', largeur: 150 },
                { nom: 'temdscabr', largeur: 220 },
                { nom: 'geccodori', largeur: 150 },
                { nom: 'gecdscori', largeur: 205 },
                { nom: 'geccoddes', largeur: 150 },
                { nom: 'gecdscdes', largeur: 220 }
            ],
            formulaire: new Formulaire([
                new FormulaireItem('temcleint', {
                    largeur: 50,
                    resourceParams: () => ({
                        rtocleint: vm.monoOccurrence.data.rtocleint,
                        vaertotyp: vm.monoOccurrence.data.vaertotyp
                    })
                }),
                new FormulaireItem('geccleintori', { largeur: 25 }),
                new FormulaireItem('geccleintdes', { largeur: 25 })
            ])
        };

        //methode pour echelon
        vm.rmnMultiOccurrenceOptions = {
            bloc: 'rmn',
            fonctions: {
                importation: true,
                nouveau: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER'),
                edition: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER'),
                supprime: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER')
            },
            colonnesVisibles: [
                { nom: 'urgcod', largeur: 90 },
                { nom: 'urgdscabr', largeur: 260 },
                { nom: 'strcod', largeur: 90 },
                { nom: 'strdsc', largeur: 200 },
                { nom: 'geccod', largeur: 150 },
                { nom: 'vaermnmthechdsc', largeur: 180 }
            ],
            formulaire: new Formulaire([
                new FormulaireItem('urgcleint', {
                    resourceParams: () => ({
                        rtocleint: vm.monoOccurrence.data.rtocleint,
                        vaertotyp: vm.monoOccurrence.data.vaertotyp
                    })
                }),
                new FormulaireItem('strcleint'),
                new FormulaireItem('geccleint'),
                new FormulaireItem('vaermnmthech')
            ])
        };

        //titre d'emploi
        vm.rtzMultiOccurrenceOptions = {
            bloc: 'rtz',
            fonctions: {
                importation: true
            },
            colonnesVisibles: ['temcod', 'temdscabr'],
            formulaire: new Formulaire([new FormulaireItem('temcleint', { largeur: 100 })])
        };

        //Suppl. salarial
        vm.risMultiOccurrenceOptions = {
            bloc: 'ris',
            fonctions: {
                importation: true,
                nouveau: (vm.valeursEcran.vaertostu === 'INI' || vm.valeursEcran.vaertostu === 'ENC'),
                edition: (vm.valeursEcran.vaertostu === 'INI' || vm.valeursEcran.vaertostu === 'ENC'),
                supprime: (vm.valeursEcran.vaertostu === 'INI' || vm.valeursEcran.vaertostu === 'ENC')
            },
            colonnesVisibles: [
                { nom: 'tagcod', largeur: 90 },
                { nom: 'tagdscabr', largeur: 180 },
                { nom: 'vaerisimpdsc', largeur: 180 }
            ],
            formulaire: new Formulaire([new FormulaireItem('tagcleint', { largeur: 60 }), new FormulaireItem('vaerisimp', { largeur: 30 })])
        };

        //bac a exclure
        vm.rbqMultiOccurrenceOptions = {
            bloc: 'rbq',
            fonctions: {
                importation: true,
                nouveau: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER'),
                edition: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER'),
                supprime: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER')
            },
            colonnesVisibles: [
                { nom: 'bqecod', largeur: 90 },
                { nom: 'bqedsc', largeur: 180 }
            ],
            formulaire: new Formulaire([new FormulaireItem('bqecleint', { largeur: 100 })])
        };

        //rce a calc
        vm.rorMultiOccurrenceOptions = {
            bloc: 'ror',
            fonctions: {
                importation: true,
                nouveau: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER'),
                edition: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER'),
                supprime: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER')
            },
            colonnesVisibles: [
                { nom: 'rcecod', largeur: 130 },
                { nom: 'rcedsc', largeur: 200 },
                { nom: 'rordatdeb', largeur: 100 },
                { nom: 'rordatfin', largeur: 100 },
                { nom: 'rcecodgen', largeur: 130 },
                { nom: 'rcedscgen', largeur: 225 },
                { nom: 'rorflgannciv', largeur: 100 },
                {
                    nom: 'tagcod',
                    largeur: 150,
                    hidden: () => !vm.monoOccurrence.data.vaertomodcal
                },
                {
                    nom: 'tagdscabr',
                    largeur: 225,
                    hidden: () => !vm.monoOccurrence.data.vaertomodcal
                },
                {
                    nom: 'rorflgadmseu',
                    largeur: 110,
                    hidden: () => !vm.monoOccurrence.data.vaertomodcal
                },
                { nom: 'rorflgemp', largeur: 90 },
                { nom: 'rorflgemr', largeur: 90 },
                { nom: 'rorflgqteadm', largeur: 90 },
                { nom: 'rorflgsaladm', largeur: 90 }
            ],
            formulaire: new Formulaire([
                new FormulaireItem('rcecleint', { largeur: 50 }),
                new FormulaireItem('rordatdeb', { largeur: 25 }),
                new FormulaireItem('rordatfin', { largeur: 25 }),
                new FormulaireItem('rcecleintgen', { largeur: 70 }),
                new FormulaireItem('rorflgannciv', { largeur: 20 }),
                new FormulaireItem('tagcleint', {
                    largeur: 70,
                    hidden: () => !vm.monoOccurrence.data.vaertomodcal
                }),
                new FormulaireItem('rorflgadmseu', {
                    largeur: 20,
                    hidden: () => !vm.monoOccurrence.data.vaertomodcal
                }),
                new FormulaireItem('rorflgemp', { largeur: 25 }),
                new FormulaireItem('rorflgemr', { largeur: 25 }),
                new FormulaireItem('rorflgqteadm', { largeur: 25 }),
                new FormulaireItem('rorflgsaladm', { largeur: 25 })
            ])
        };

        //reg retraite
        vm.ocdMultiOccurrenceOptions = {
            bloc: 'ocd',
            fonctions: {
                importation: true,
                nouveau: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER'),
                edition: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER'),
                supprime: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER')
            },
            colonnesVisibles: [
                { nom: 'fpncod', largeur: 90 },
                { nom: 'fpndsc', largeur: 230 },
                { nom: 'cdfcod', largeur: 150 },
                { nom: 'cdfdsc', largeur: 230 },
                { nom: 'ocdmnt', largeur: 150 }
            ],
            formulaire: new Formulaire([
                new FormulaireItem('fpncleint', { largeur: 50 }),
                new FormulaireItem('cdfcleint', { largeur: 50 }),
                new FormulaireItem('ocdmnt', { largeur: 25 })
            ])
        };

        //interets
        vm.rinMultiOccurrenceOptions = {
            bloc: 'rin',
            fonctions: {
                importation: true,
                nouveau: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER'),
                edition: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER'),
                supprime: !(vm.valeursEcran.vaertostu === 'ANN' || vm.valeursEcran.vaertostu === 'TER')
            },
            colonnesVisibles: [
                { nom: 'rindatdeb', largeur: 100 },
                { nom: 'rindatfin', largeur: 100 },
                { nom: 'vaerintypdsc', largeur: 180 },
                { nom: 'tagcod', largeur: 90 },
                { nom: 'tagdscabr', largeur: 180 },
                { nom: 'rinprcint', largeur: 90 }
            ],
            formulaire: new Formulaire([
                new FormulaireItem('rindatdeb', { largeur: 25 }),
                new FormulaireItem('rindatfin', { largeur: 25 }),
                new FormulaireItem('vaerintyp', { largeur: 25 }),
                new FormulaireItem('rinprcint', { largeur: 25 }),
                new FormulaireItemSautDeLigne(),  
                new FormulaireItemSautDeColonne(),              
                new FormulaireItem('tagcleint', { largeur: 50 })
            ])
        };

        //messages
        vm.rmsMultiOccurrenceOptions = {
            bloc: 'rms',
            forcerEtatPredefinisDepart: 'EMP',
            etatsPredefinis: [
                {
                    nom: 'EMP',
                    filtres: [
                        {
                            colonne: 'v_type',
                            operateur: Operateur.EGALE,
                            valeur: 'EMP'
                        }
                    ],
                    colonnesVisibles: ['ppacod', 'eplnummat', 'eplnomprn', 'vaermstypdsc', 'flg_err', 'flg_avedbg']
                },
                {
                    nom: 'TOUS',
                    filtres: [
                        {
                            colonne: 'v_type',
                            operateur: Operateur.EGALE,
                            valeur: 'TOUS'
                        }
                    ],
                    colonnesVisibles: ['eplnummat', 'eplnomprn', 'ppacod', 'rmsmsg', 'vaermstypdsc', 'tagcod', 'tagdscabr', 'rmstau', 'temcod', 'temdscabr', 'vaermscatdsc']
                }
            ],
            colonnesVisibles: [
                { nom: 'eplnummat', largeur: 100 },
                { nom: 'eplnomprn', largeur: 262 },
                { nom: 'ppacod', largeur: 100 },
                { nom: 'rmsmsg', largeur: 500 },
                { nom: 'vaermstypdsc', largeur: 150 },
                { nom: 'flg_err', largeur: 100 },
                { nom: 'flg_avedbg', largeur: 130 },
                { nom: 'tagcod', largeur: 90 },
                { nom: 'tagdscabr', largeur: 280 },
                { nom: 'rmstau', largeur: 150 },
                { nom: 'temcod', largeur: 150 },
                { nom: 'temdscabr', largeur: 280 },
                { nom: 'vaermscatdsc', largeur: 150 }
            ]
        };

        //details messages
        vm.rmsDetMultiOccurrenceOptions = {
            bloc: 'det',
            colonnesFixesGauche: [{ nom: 'ppacod', largeur: 90 }],
            colonnesVisibles: [
                { nom: 'rmsmsg', largeur: 500 },
                { nom: 'tagcod', largeur: 90 },
                { nom: 'tagdscabr', largeur: 280 },
                { nom: 'rmstau', largeur: 120 },
                { nom: 'temcod', largeur: 130 },
                { nom: 'temdscabr', largeur: 280 },
                { nom: 'vaermscatdsc', largeur: 150 }
            ]
        };
    }
}
